import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { TagTypes } from '~/api';
import dashboardApi from '../api/dashboard-api';
import { API_CACHE_NAME } from '~/app/service-worker';
import logger from '~/utils/logger/logger';
import assetsAPI from '~/api/assets-api/assets-api';

const useInvalidateTagsAndCache = () => {
  const dispatch = useDispatch();
  const invalidateCache = useCallback(async () => {
    if ('caches' in globalThis) {
      try {
        await caches.delete(API_CACHE_NAME);
        logger.debug('SW cache purged successfully');
      } catch (error) {
        logger.warn('Failed to purge SW cache:', error);
      }
    }
    dispatch(dashboardApi.util.invalidateTags([TagTypes.Dashboard]));
    dispatch(assetsAPI.util.invalidateTags([TagTypes.AssetMap]));
  }, [dispatch]);
  return invalidateCache;
};
export { useInvalidateTagsAndCache };
